export class CustomerDataController {
  constructor(proService) {
    this.proService = proService;
    this.$onInit = () => {
    };
  }
}
CustomerDataController.$inject = [
  "ProService"
];
